import type { WorkSpace } from 'features/workspace'

import { functions } from 'tools/functions'

const INITIAL_HOURS = '09:00-19:00'

const DAYS: WorkSpace.WeekDayName[] = [
	'monday',
	'tuesday',
	'wednesday',
	'thursday',
	'friday',
	'saturday',
	'sunday'
]

type AppWorkingHours = Record<WorkSpace.WeekDayName, Day>

interface Day {
	errorMessage: string
	isSelected: boolean
	value: string
}

const isWeekDay = (index: number) => index < 5
const getInitials = (isSelected?: (index: number) => boolean) =>
	DAYS.reduce((values, day, index) => {
		values[day] = {
			errorMessage: '',
			isSelected: isSelected ? isSelected(index) : false,
			value: INITIAL_HOURS
		}

		return values
	}, {} as AppWorkingHours)

function transformToWorkingHours(hours: AppWorkingHours) {
	const workspaceHours: Partial<WorkSpace.WorkingHours> = {}

	let isValid = true,
		oneOrMoreSelected = false

	for (const day of DAYS) {
		const value = hours[day]

		if (!value.isSelected) {
			workspaceHours[day] = []
			continue
		}

		const validationMessage = functions.validateHours(value.value)
		const [start, end] = value.value && value.value.split('-')
		const [startTimeInHours, startTimeInMinutes] = start.split(':').map(Number)
		const [endTimeInHours, endTimeInMinutes] = end.split(':').map(Number)

		const totalTime = functions.getTotalTime(
			startTimeInHours,
			endTimeInHours,
			startTimeInMinutes,
			endTimeInMinutes
		)

		hours[day].errorMessage = validationMessage
		if (validationMessage.length) {
			isValid = false
		}
		oneOrMoreSelected = true
		workspaceHours[day] = [
			{
				duration: totalTime,
				start: startTimeInHours * 60 + startTimeInMinutes
			}
		]
	}

	return {
		isValid,
		oneOrMoreSelected,
		workspaceHours
	}
}

export { DAYS, getInitials, isWeekDay, transformToWorkingHours }
export type { AppWorkingHours, Day }
